<template>
	<div class="page_content explore_entity_inside program degree_req stream" aria-label="Program Guide Streams">

    	<div class="row page-heading">
      		<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 input module_heading">
        		<span class="module_icon  icon-list"></span>
        		<template v-if="formattedProgramGuide && formattedProgramGuide.title">
              <program-guide-title :program-guide="formattedProgramGuide"></program-guide-title>
            </template>
      		</div>

      		<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 btn_container" v-if="showBackToResultButton">
        		<b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
              <span class="btn_ic ic-back"></span>
              <span class="btn_txt"> {{ deCamelCase() }} </span>
            </b-btn>
            <span v-if="showAddCompletedCoursesOnResult">
              <b-button @click="addCompletedCourses" aria-label="add completed courses">Add Completed Courses</b-button>
            </span>
      		</div>
    	</div>


    	<div class="page_content_container">

			<div v-if="formattedProgramGuide && formattedProgramGuide.cipCode">
      			<program-guide-menu
          			:cipCode="formattedProgramGuide.cipCode"
          			:programGuideCode="formattedProgramGuide.code"
          			:type="formattedProgramGuide.type"
          			:returnTo="returnTo"
          			:active="'streams'">
      			</program-guide-menu>
    		</div>

    		<div class="pg_content grid_view">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">

					<div class="row pg_sec">


		          		<div class="col-12 sec_content">
							<div class="row">
		          				<div class="col-12 tbl_sec">

                  <template v-if="!isPathwaySelected">
  		          		<template v-if="formattedProgramGuide && formattedProgramGuide.pathwayProgramGuides.length > 0">
											<template v-for="path in formattedProgramGuide.pathwayProgramGuides">

												<div class="row lst_row">
													<div class="col-2 thumbnail_container ace_sec" @click="showPathwayDetail(path)">
														<div class="thumbnail_img" v-if="path.thumbnailURL">
															<img v-bind:src="path.thumbnailURL" alt="Img">
														</div>
														<div v-else class="thumbnail_default">
															<div class="thumbnail_txt">Acct</div>
														</div>
													</div>
													<div class="col-10 entity_detail_section">
														<div class="row">
															<div class="col-12 title">
																<span class="title_txt">
																	<b-link @click="showPathwayDetail(path)">{{path.title}}</b-link>
																</span>
																<!--
																<span class="ic ic8-bookmark3"></span>
																-->
															</div>
														</div>
														<div class="row">
															<div class="col-12 other_details">
																Minimum Course : {{path.minimumCourses}} / Minimum Credit : {{path.minimumCredits}}
															</div>
														</div>
													</div>
												</div>
											</template>

                      <!--
  										<div class="row program-guide-section prog_detail-section">
  											<div class="col-12 mid-panel" style="width: 100%; max-width: 100%; height: 100%; border: none;">
  								        		<div id="degreeRequirementsPage">
  								          			<div class="degreeRequirements pg_content_sec ace_sec_txt" :aria-label="formattedProgramGuide.requirements">
  								            			<div v-html="formattedProgramGuide.requirements"></div>
  									          		</div>
  									        	</div>
  									    	</div>
  									    </div>
                      -->
  									</template>

  									<template v-else>
             					<div class="msg_no_data empty_pattern ace_sec_txt" aria-label="No data available for this program guide">
             					        This program doesn't have any pathways.
             					</div>
             				</template>
                  </template>

                  <template v-if="isPathwaySelected">
										<div class="pg_win entity_info">

											<div class="pg_win_hd">
												<!--
												<div class="ic_container">
													<span class="ic ic8-backbutton" aria-label="back" title="back" @click="showAllPathways()"></span>
												</div>
												-->
												<div class="hd_txt">
													<span class="lnk_txt" @click="showAllPathways()">{{streamsLabel}}</span> > {{selectedPathway.title}}
												</div>
											</div>

											<div class="pg_win_content">

												<div class="row program-guide-section prog_detail-section" v-if="selectedPathway && selectedPathway.requirements">
													<div class="col-12 mid-panel" style="width: 100%; max-width: 100%; height: 100%; border: none;">
														<div id="degreeRequirementsPage">
															<div class="degreeRequirements pg_content_sec ace_sec_txt" :aria-label="selectedPathway.requirements">
																<div v-html="selectedPathway.requirements"></div>
															</div>
														</div>
													</div>
												</div>
												<div v-else class="msg_no_data empty_pattern ace_sec_txt" aria-label="No data available for this program guide">
													Requirements for this pathway are not available.
												</div>

											</div>

										</div>
									</template>

							    </div>

		            		</div>
		          		</div>
		          	</div>

        		</div> <!-- .content_mid_panel -->
				<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">
					<div class="row pg_sec">

	        			<div class="col-12 hd ace_sec_hd" aria-label="Streams" v-if="!(formattedProgramGuide && formattedProgramGuide.cipCode)">
		          			<h2>Streams</h2>
		          			<span class="hd_bdr"></span>
		          		</div>

		          		<div class="col-12 sec_content">
							<div class="row">
		          				<div class="col-12 tbl_sec">

		          					<template v-if="formattedProgramGuide && formattedProgramGuide.cipCode">
										<program-guide-recommendations
	              							:cipCode="formattedProgramGuide.cipCode"
	              							:programGuideCode="formattedProgramGuide.code"
	              							:type="formattedProgramGuide.type"
	              							:returnTo="returnTo"
	              							:showBookmarks="true"
                              :isStreamsPage="true">
	          							</program-guide-recommendations>
									</template>

									<template v-else>
			           					<div class="msg_no_data empty_pattern ace_sec_txt" aria-label="No Streams Available for this Program">
			           						No Streams Available for this Program
			           					</div>
			           				</template>

							    </div>

		            		</div>
		          		</div>

		          	</div>
        		</div> <!-- .content_mid_panel -->
        	</div> <!-- .pg_content -->

		</div> <!-- .page_content_container -->


		<div class="loading-spinner">
			<b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
				<div class="text-center" style="color: #FFF">
					<i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
				</div>
			</b-modal>
		</div>


	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import ProgramGuideMenu from './ProgramGuideMenu'
import ProgramGuideTitle from './ProgramGuideTitle'
import ProgramGuideRecommendations from './ProgramGuideRecommendations'
import ProgramGuideSummary from './ProgramGuideSummary'

export default {
  name: 'program-guide-streams',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'showBackToResultButton', 'loadDataFromServer'],
  components: {
    ProgramGuideMenu,
    ProgramGuideTitle,
    ProgramGuideRecommendations,
    ProgramGuideSummary
  },
  data: () => {
    return {
      DEFAULT_TYPE: 'MAJOR',
      DEFAULT_RETURN_TO: 'exploreProgramGuideResults',
      EXPLORE_RESULTS: 'exploreProgramGuideResults',
      selectedPathway: {},
      isPathwaySelected: false,
    }
  },

  async mounted () {
    this.loadDataForProgramGuideStreams()
  },

  methods: {
    ...mapActions([
      'loadProgramGuide',
      'loadProgramGuideCareers',
      'loadLogDashboardActivity'
    ]),
    addCompletedCourses () {
      return this.$router.push({name: 'selfReportedCourseList'})
    },
    async loadDataForProgramGuideStreams () {
      let cipCode = this.cipCode
      let programGuideCode = this.programGuideCode
      let returnTo = this.returnTo && this.returnTo.length ? this.returnTo : this.DEFAULT_RETURN_TO
      if (!cipCode || !programGuideCode) {
        return this.$router.push({ name: returnTo })
      }
      let programGuide = await this.loadProgramGuide({
        cipCode: cipCode,
        programGuideCode: programGuideCode,
        type: this.programGuideType,
        loadDataFromServer: true
      })
      if (!programGuide || !programGuide.cipCode) {
        return this.$router.push({ name: returnTo })
      }
      // load related career information, if any exists
      await this.loadProgramGuideCareers({ cipCode: programGuide.cipCode, code: programGuide.code, showAllOccupations: true })
      this.loadLogDashboardActivity({action: 'viewProgramStreams', page: 'programStreams', link: '', programCipCode: cipCode})
    },
    returnToClicked () {
      let returnTo = this.returnTo || this.DEFAULT_RETURN_TO
      return this.$router.push({ name: returnTo })
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'return to all results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return result
    },
    getCoursePlanningPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getCoursePlanningPackage(packages)
    },
    showPathwayDetail (path) {
      let routerParams = {
        cipCode: this.cipCode,
        programGuideCode: this.programGuideCode,
        type: this.type,
        returnTo: 'exploreProgramGuideResults',
        showBackToResultButton: true,
        isWidget: this.isWidget,
        selected: this.selected,
        selectedPathway: path
      }
      let queryParam = {
        returnTo: this.$route.query.returnTo || this.DEFAULT_RETURN_TO
      }
      this.$router.push({ name: 'programGuidePathwayDetail', params: routerParams, query: queryParam })
    },
    showAllPathways () {
      this.isPathwaySelected = false
      this.selectedPathway = {}
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    }
  },
  computed: {
    ...mapState({
      'programGuide': state => state.programguide.programGuideObject,
      'careersObject': state => state.programguide.careers,
      'careerResult': state => state.programguide.careerResult,
      'packages': state => state.institution.packages,
      'enabledFeatures': state => state.institution.enabledFeatures
    }),
    formattedProgramGuide () {
      let formattedProgramGuide = this.programGuide
      return formattedProgramGuide
    },
    formattedCareers () {
      let careers = this.careersObject
      let formattedCareers = []
      if (!careers || !careers.targetOccupations || !careers.targetOccupations.length || !careers.targetOccupations.length === 0) {
        return formattedCareers
      }
      careers.targetOccupations.forEach((career) => {
        formattedCareers.push(JSON.parse(career))
      })
      return formattedCareers
    },
    formattedCareer () {
      let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
      if (!formattedCareer || !formattedCareer.uuid) {
        return {}
      }
      return formattedCareer
    },
    recommendationFeatureMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFeatureFromPackage(coursePlanningPackage, featureId)
    },
    recommendationFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
    },

    exploreProgramDetailFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    streamsLabel () {
      const defaultLabel = 'Pathways'
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.streamsTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.streamsTab.label || defaultLabel
    },
    showRecommendationsTab () {
      return this.isRecommendationFeatureEnabled && (this.isAlumniStreamRecommendationsEnabled || this.isAdvisorStreamRecommendationsEnabled)
    },
    isRecommendationFeatureEnabled () {
      return this.recommendationFeatureMap.enabled
    },
    isAlumniStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAlumniStreamRecommendations.enabled
    },
    isAdvisorStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAdvisorStreamRecommendations.enabled
    },
    programGuideType () {
      let programGuideType = this.type
      if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
        programGuideType = this.DEFAULT_TYPE
      }
      return programGuideType
    },
    showAddCompletedCoursesOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultAddCompletedCourses) {
        return false
      }
      return exploreProgramsFlagMap.searchResultAddCompletedCourses.enabled
    }
  },
  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideStreams.vue